<template>
  <div>
    <HomeBanner :video="video" :location="location" v-if="showBackground"></HomeBanner>
    <div class="details-box" v-bind:class="[page ? 'settingsBox': '',
      standaloneMode ? 'details-box-standalone': '']"
      v-bind:style="{ backgroundColor: backgroundColor}">
      <iframe src="/audio/silence.mp3" allow="autoplay" class="dummy-audio"></iframe>
      <Player v-on:open="togglePage" v-on:setBackground="setBackground"
        v-on:msg="showToastr" :isMobile="isMobile"></Player>
      <transition name="card">
        <Settings v-if="page === 'settings'" v-on:close="togglePage"
      :userPreference="userPreference"></Settings>
      </transition>
      <transition name="card">
        <About v-if="page === 'about'" v-on:close="togglePage"></About>
      </transition>
      <transition name="card">
        <Partnerships v-if="page === 'partnerships'" v-on:close="togglePage"></Partnerships>
      </transition>
      <transition name="card">
        <Instructions v-if="page === 'instructions'" v-on:close="togglePage"></Instructions>
      </transition>
    </div>
    <footer class="footer">
      <p title="About" class="footer-links" @click="togglePage('about')">About Ragya</p>
      <!-- <a class="footer-links" href="">Signup</a> -->
      <!-- <p class="footer-links" @click="togglePage('partnerships')">Partnerships</p> -->

      <p class="footer-links" @click="openMenu" v-click-outside="hideMenu"
        v-if="isIOSMobile && !standaloneMode">
        <img src="~@/assets/img/more.svg" class="icon"/>
      </p>
      <div class="share">
        <p class="footer-text">Share</p>
        <a class="footer-icons" href="https://www.facebook.com/sharer.php?u=https://ragya.com" target="_blank" alt="facebook">
          <img src="~@/assets/img/facebook.svg" alt="facebook" class="facebook-icon"/>
        </a>
        <a href="//twitter.com/share?text=Listen to an uninterrupted supply of Indian classical music based on the time of the day on &url=https://ragya.com" class="footer-icons twitter" target="blank">
          <img src="~@/assets/img/twitter.svg" alt="twitter" class="icon"/>
        </a>
        <a class="footer-icons webshare" @click="webShare">
          <img src="~@/assets/img/webshare.svg" alt="share" class="icon"/>
        </a>
      </div>
    </footer>
    <transition name="fade">
      <div class="toastr-container" v-show="userMsg">
        <p class="toastr"> {{ userMsg }}</p>
      </div>
    </transition>
    <transition name="fade">
      <div class="menu" v-show="isMenu">
        <p class="menu-content" @click="togglePage('instructions')">
          + Add Ragya to your home screen
        </p>
        <img src="~@/assets/img/close.svg" alt="close"
          class="close-menu-icon" aria-label="close" @click="hideMenu"/>
      </div>
    </transition>
    <img src="~@/assets/img/vijay-kaka.png" class="hide"/>
  </div>
</template>

<script>
import vClickOutside from 'v-click-outside';
import Utils from '../mixins/utils';

export default {
  name: 'Home',
  data() {
    return {
      page: '',
      video: '',
      location: '',
      showBackground: false,
      userMsg: '',
      timeOutInterval: 5000,
      userPreference: {
        gender: ['female', 'male'],
        musictype: ['vocal', 'instrumental'],
      },
      backgroundColor: '',
      standaloneMode: false,
      isMobile: false,
      isIOSMobile: false,
      isMenu: false,
    };
  },
  components: {
    HomeBanner: () => import('../components/HomeBanner.vue'),
    Player: () => import('../components/Player.vue'),
    Settings: () => import('../components/Settings.vue'),
    About: () => import('../components/About.vue'),
    Partnerships: () => import('../components/Partnerships.vue'),
    Instructions: () => import('../components/Instructions.vue'),
  },
  methods: {
    togglePage(page = '') {
      this.page = page;
    },
    setBackground(video, location, backgroundColor) {
      this.video = video;
      this.location = location;
      this.backgroundColor = backgroundColor;
      this.showBackground = true;
    },
    showToastr(msg) {
      if (document.querySelector('.toastr-container').style.display !== 'block') {
        this.userMsg = msg;
        setTimeout(() => {
          this.userMsg = '';
        }, this.timeOutInterval);
      }
    },
    openMenu() {
      this.isMenu = true;
    },
    hideMenu() {
      this.isMenu = false;
    },
    webShare() {
      if (navigator.share) {
        navigator.share({
          title: this.$appName,
          text: 'Ragya',
          url: window.location.origin,
        });
      }
    },
  },
  mixins: [Utils],
  directives: {
    clickOutside: vClickOutside.directive,
  },
  mounted() {
    if (!navigator.share) {
      document.querySelector('.webshare').classList.add('hide');
    }
    if (window.navigator.standalone === true
      || window.matchMedia('(display-mode: standalone)').matches) {
      this.standaloneMode = true;
    }
    this.isMobile = /mobile/i.test(window.navigator.userAgent);
    this.isIOSMobile = /mobile/i.test(window.navigator.userAgent)
     && navigator.userAgent.indexOf('Chrome') === -1
     && navigator.userAgent.indexOf('Safari') > -1;
  },
};
</script>
